import { render, staticRenderFns } from "./ReferralsSettings.vue?vue&type=template&id=6394596e&scoped=true&"
import script from "./ReferralsSettings.vue?vue&type=script&lang=js&"
export * from "./ReferralsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ReferralsSettings.vue?vue&type=style&index=0&id=6394596e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394596e",
  null
  
)

export default component.exports